import React, { useState } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import TestOption from '../compnents/TestOption';
import FileUploader from '@jumbo/Dashboards/Media/FileUploader';
import TestTitle from '../compnents/TestTitle';
import ImagePicker from '../compnents/ImagePicker';
import ImgaeSelector from '../compnents/ImgaeSelector';

const useStyles = makeStyles(theme => ({
  cardContainer: {
    marginTop: 10,
  },
  answerSelctText: {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
  },
}));

const PuzzleQuestionElment = ({
  questoinTitle,
  setQuestoinTitle,
  cover,
  setCover,
  score,
  setScore,
  puzzleSource,
  setPuzzleSource,
  puzzleRow,
  setPuzzleRow,
  puzzleColumn,
  setPuzzleColumn,
}) => {
  const classes = useStyles();
  const [openFileUploader, setOpenFileUploader] = useState(false);

  return (
    <React.Fragment>
      <TestTitle value={questoinTitle} handeChange={value => setQuestoinTitle(value)} />
      <Grid item xs={12}>
        <Typography className={classes.answerSelctText}>انتخاب تصویر سوال</Typography>
        <ImagePicker
          cover={cover}
          handlePick={() => setOpenFileUploader(true)}
          handleRevome={() => setCover('')}
          previewStyles={{ marginInline: 'auto', marginBlock: '20px' }}
          placeHolderStyles={{ marginInline: 'auto', marginBlock: '20px' }}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography className={classes.answerSelctText}>انتخاب تصویر پازل</Typography>
        <ImgaeSelector puzzleSource={puzzleSource} setPuzzleSource={setPuzzleSource} />
      </Grid>
      <TestOption
        text={''}
        title={'تعداد سطر'}
        type={'number'}
        value={puzzleRow}
        handleChange={value => setPuzzleRow(+value)}
      />
      <TestOption
        text={''}
        title={'تعداد ستون'}
        type={'number'}
        value={puzzleColumn}
        handleChange={value => setPuzzleColumn(+value)}
      />
      <TestOption text={''} title={'پله'} type={'number'} value={score} handleChange={value => setScore(+value)} />
      <FileUploader
        selectMode
        open={openFileUploader}
        handleClose={() => setOpenFileUploader(false)}
        handleSelect={selected => setCover(selected)}
        selectedItem={cover}
        imageSelector={true}
      />
    </React.Fragment>
  );
};

export default PuzzleQuestionElment;
